import { useState } from "react";
import { DefaultLayout } from "src/layouts/DefaultLayout";
import { ForgotPassword } from "src/components/ForgotPassword";
import { PasswordConfirmationForm } from "src/components/ForgotPassword/PasswordConfirmationForm";
import { requestPasswordReset } from "src/libs/user-lib";
import { toastError, toastSuccess } from "src/libs/toast-lib";
import { ResetPasswordForm } from "src/components/ForgotPassword/ResetPasswordForm";
import { ResendVerifyModal } from "src/components/AccountVerify/ResendVerifyModal";

export default function ResetPasswordPage() {
  const [email, setEmail] = useState("");
  const [allowReset, setAllowReset] = useState(false);
  const [showVerify, setShowVerify] = useState(false);

  const handleVerifyComplete = () => {
    toastSuccess(
      "You should receive a verification email shortly. Click the link in the email to verify your account and then reset your password.",
      { autoClose: 12000 }
    );
  };

  const handleResetPassword = async (email: string) => {
    setEmail(email);

    try {
      await requestPasswordReset(email);
      setAllowReset(true);
    } catch (err) {
      const errName = err instanceof Error ? err.name : "Unknown";

      switch (errName) {
        case "InvalidParameterException": {
          setShowVerify(true);
          break;
        }
        case "UserNotFoundException": {
          toastError(
            "Unable to find a Memento account for this e-mail address."
          );
          break;
        }
        case "LimitExceededException": {
          toastError("Attempt limit exceeded, please try after some time.");
          break;
        }
        default: {
          toastError(
            "Something went wrong and your password reset could not be initiated. Please try again."
          );
        }
      }
    }
  };

  return (
    <DefaultLayout>
      <ResendVerifyModal
        isOpen={showVerify}
        setIsOpen={setShowVerify}
        email={email}
        message="You must verify your account before resetting your password."
        onComplete={handleVerifyComplete}
      />
      <ForgotPassword>
        {allowReset ? (
          <PasswordConfirmationForm username={email} />
        ) : (
          <ResetPasswordForm onReset={handleResetPassword} />
        )}
      </ForgotPassword>
    </DefaultLayout>
  );
}

ResetPasswordPage.enableSessionRecording = true;
